// Created by: Imran Khan July 2026
import React from "react";
import { formatCurrency } from "./financialYearUtils";

export default function SummaryCard({ title, value, subtitle, accent = "#1A237E", className = "" }) {
  return (
    <div className={`fy-summary-card ${className}`} style={{ borderLeftColor: accent }}>
      <span className="fy-summary-title">{title}</span>
      <strong className="fy-summary-value">{value}</strong>
      {subtitle && <small className="fy-summary-subtitle">{subtitle}</small>}
    </div>
  );
}

export function RevenueSummaryCards({ revenue }) {
  if (!revenue) return null;
  const total = Number(revenue.total) || 0;
  const pct = (part) => (total ? `${((part / total) * 100).toFixed(2)}%` : "0%");

  const items = [
    { title: "From New Orders", value: revenue.fromOrders, accent: "#4CAF50", subtitle: pct(revenue.fromOrders) },
    { title: "From New AMC", value: revenue.fromAmc, accent: "#2196F3", subtitle: pct(revenue.fromAmc) },
    //{ title: "From Services / Others", value: revenue.fromServices, accent: "#FF9800", subtitle: pct(revenue.fromServices) },
    { title: "Total Revenue", value: revenue.total, accent: "#1A237E", subtitle: "100%", highlight: true },
  ];

  return (
    <div className="fy-summary-grid">
      {items.map((item) => (
        <SummaryCard
          key={item.title}
          title={item.title}
          value={formatCurrency(item.value, "crore")}
          subtitle={item.subtitle}
          accent={item.accent}
          className={item.highlight ? "highlight" : ""}
        />
      ))}
    </div>
  );
}

export function CollectionSummaryCards({ collections }) {
  if (!collections) return null;
  const total = Number(collections.total) || 0;
  const pct = (part) => (total ? `${((part / total) * 100).toFixed(2)}%` : "0%");

  const items = [
    //{ title: "Cash Amount", value: collections.cash, accent: "#4CAF50" },
    //{ title: "Cheque Amount", value: collections.cheque, accent: "#2196F3" },
    //{ title: "Other Amount", value: collections.others, accent: "#FF9800" },
    { title: "Pending Amount", value: collections.pending, accent: "#F44336" },
  ];

  items.push({ title: "Total Collection", value: collections.total, accent: "#1A237E", highlight: true });

  return (
    <div className="fy-summary-grid">
      {items.map((item) => (
        <SummaryCard
          key={item.title}
          title={item.title}
          value={formatCurrency(item.value)}
          subtitle={item.highlight ? "100%" : pct(item.value)}
          accent={item.accent}
          className={item.highlight ? "highlight" : ""}
        />
      ))}
    </div>
  );
}
export function DetailedCollectionSummaryCard({ collectionData }) {
  if (!collectionData) return null;

  const items = [
    { title: "Total Target Amount", value: collectionData.target, accent: "#2196F3" },
    { title: "Total Due Amount", value: collectionData.due, accent: "#FF9800" },
    { title: "Total Receive Amount", value: collectionData.receive, accent: "#4CAF50" },
    { title: "Pending Amount", value: collectionData.pending, accent: "#F44336" },
  ];

  return (
    <div className="fy-summary-grid">
      {items.map((item) => (
        <SummaryCard
          key={item.title}
          title={item.title}
          value={formatCurrency(item.value)}
          accent={item.accent}
        />
      ))}
    </div>
  );
}
